import React from "react";

import airplaneCoins from "../../../../../img/landing-page/quiz/airplane-coins.png"

const LandingPageQuizWantSale = ({ next } = props) => {
	return (
		<div className="offers-landing-page-quiz-want-sale">
			<img src={airplaneCoins} alt="" />
			<div>
				<h2>QUER GANHAR DINHEIRO COM SUAS MILHAS?</h2>
				<button onClick={step => next(step)} className="btn-green-md-s">
					DESCUBRA COMO
				</button>
			</div>
		</div>
	);
};

export default LandingPageQuizWantSale;
